/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { generateFillAttributes as e, generateStrokeAttributes as l, renderDef as a, renderShape as r, getBoundingBox as t, computeBBox as s, getTransformMatrix as o } from "../../../../symbols/support/svgUtils.js";
import { getCSSFilterFromEffectList as i } from "../../../../symbols/support/utils.js";
import { isRTL as n, classes as d } from "../../../support/widgetUtils.js";
import { tsx as m } from "../../../support/jsxFactory.js";
const b = "esri-relationship-ramp",
  u = `${b}--diamond`,
  c = `${b}--square`,
  f = "http://www.w3.org/2000/svg",
  p = {
    diamondContainer: `${u}__container`,
    diamondLeftCol: `${u}__left-column`,
    diamondRightCol: `${u}__right-column`,
    diamondMidCol: `${u}__middle-column`,
    diamondMidColLabel: `${u}__middle-column--label`,
    diamondMidColRamp: `${u}__middle-column--ramp`,
    squareTable: `${c}__table`,
    squareTableRow: `${c}__table-row`,
    squareTableCell: `${c}__table-cell`,
    squareTableLabel: `${c}__table-label`,
    squareTableLabelLeftBottom: `${c}__table-label--left-bottom`,
    squareTableLabelRightBottom: `${c}__table-label--right-bottom`,
    squareTableLabelLeftTop: `${c}__table-label--left-top`,
    squareTableLabelRightTop: `${c}__table-label--right-top`
  };
function h(e, l, a = {}) {
  const {
      focus: r,
      labels: t
    } = e,
    s = !!r,
    o = T(e, l, a),
    i = {
      justifyContent: "center"
    },
    b = n();
  return s ? m("div", {
    class: p.diamondContainer,
    styles: i
  }, m("div", {
    class: p.diamondLeftCol
  }, b ? t.right : t.left), m("div", {
    class: p.diamondMidCol
  }, m("div", {
    class: p.diamondMidColLabel
  }, t.top), o, m("div", {
    class: p.diamondMidColLabel
  }, t.bottom)), m("div", {
    class: p.diamondRightCol
  }, b ? t.left : t.right)) : m("div", {
    class: p.squareTable
  }, m("div", {
    class: p.squareTableRow
  }, m("div", {
    class: d(p.squareTableCell, p.squareTableLabel, p.squareTableLabelRightBottom)
  }, b ? t.top : t.left), m("div", {
    class: p.squareTableCell
  }), m("div", {
    class: d(p.squareTableCell, p.squareTableLabel, p.squareTableLabelLeftBottom)
  }, b ? t.left : t.top)), m("div", {
    class: p.squareTableRow
  }, m("div", {
    class: p.squareTableCell
  }), o, m("div", {
    class: p.squareTableCell
  })), m("div", {
    class: p.squareTableRow
  }, m("div", {
    class: d(p.squareTableCell, p.squareTableLabel, p.squareTableLabelRightTop)
  }, b ? t.right : t.bottom), m("div", {
    class: p.squareTableCell
  }), m("div", {
    class: d(p.squareTableCell, p.squareTableLabel, p.squareTableLabelLeftTop)
  }, b ? t.bottom : t.right)));
}
function k(e, l, a) {
  const r = `${a}_arrowStart`,
    t = `${a}_arrowEnd`,
    s = "left" === e,
    o = {
      markerStart: null,
      markerEnd: null
    };
  switch (l) {
    case "HL":
      s ? o.markerStart = `url(#${t})` : o.markerEnd = `url(#${r})`;
      break;
    case "LL":
      o.markerStart = `url(#${t})`;
      break;
    case "LH":
      s ? o.markerEnd = `url(#${r})` : o.markerStart = `url(#${t})`;
      break;
    default:
      o.markerEnd = `url(#${r})`;
  }
  return o;
}
function T(n, d, b = {}) {
  const {
      focus: u,
      numClasses: c,
      colors: h,
      rotation: T
    } = n,
    {
      opacity: _,
      effectList: q,
      ariaLabel: L
    } = b,
    g = b.size ?? 60,
    $ = !!u,
    C = Math.sqrt(g ** 2 + g ** 2) + ($ ? 0 : 5),
    v = [],
    w = [],
    y = [],
    x = (g || 75) / c;
  for (let s = 0; s < c; s++) {
    const o = s * x;
    for (let i = 0; i < c; i++) {
      const n = i * x,
        d = e(h[s][i]),
        m = l(null),
        b = {
          type: "rect",
          x: n,
          y: o,
          width: x,
          height: x
        },
        u = a(d);
      u && v.push(u);
      const c = r(b, d.fill, m, null);
      c && w.push(c), y.push(t(b));
    }
  }
  const R = 10,
    E = 15,
    M = 15,
    S = 10;
  let j = null;
  $ || (j = "margin: -15px -15px -18px -15px");
  const B = k("left", u, d),
    H = k("right", u, d),
    U = s(y),
    W = o(U, C, C, 0, !1, T, !1),
    X = o(U, C, C, 0, !1, $ ? -45 : null, !1),
    Y = {
      filter: i(q) ?? void 0,
      opacity: null == _ ? "" : `${_}`
    };
  return m("div", {
    class: $ ? p.diamondMidColRamp : p.squareTableCell,
    styles: Y
  }, m("svg", {
    "aria-labelledBy": L,
    focusable: !1,
    height: C,
    role: "image",
    style: j,
    width: C,
    xmlns: f
  }, m("defs", null, m("marker", {
    id: `${d}_arrowStart`,
    markerHeight: "10",
    markerUnits: "strokeWidth",
    markerWidth: "10",
    orient: "auto",
    refX: "5",
    refY: "5"
  }, m("polyline", {
    fill: "none",
    points: "0,0 5,5 0,10",
    stroke: "#555555",
    "stroke-width": "1"
  })), m("marker", {
    id: `${d}_arrowEnd`,
    markerHeight: "10",
    markerUnits: "strokeWidth",
    markerWidth: "10",
    orient: "auto",
    refX: "0",
    refY: "5"
  }, m("polyline", {
    fill: "none",
    points: "5,0 0,5 5,10",
    stroke: "#555555",
    "stroke-width": "1"
  })), v), m("g", {
    transform: W
  }, w), m("g", {
    transform: X
  }, m("line", {
    fill: "none",
    "marker-end": B.markerEnd,
    "marker-start": B.markerStart,
    stroke: "#555555",
    "stroke-width": "1",
    x1: -R,
    x2: -R,
    y1: g - E,
    y2: E
  }), m("line", {
    fill: "none",
    "marker-end": H.markerEnd,
    "marker-start": H.markerStart,
    stroke: "#555555",
    "stroke-width": "1",
    x1: M,
    x2: g - M,
    y1: g + S,
    y2: g + S
  }))));
}
export { h as renderRelationshipRamp };